import { type FC, type ReactElement } from "react";
import { type BaseFieldProps, Field, type WrappedFieldProps } from "redux-form";

import style from "@/ui-modules/core/form/layout/styles/Form.module.scss";

import { Checkbox } from "../forms/Checkbox.js";
import { FormInputGroup } from "@/ui-modules/core/form/layout/FormGroup.js";
import { FormInputWidget } from "@/ui-modules/core/form/layout/FormInputWidget.js";
import { FormLabel } from "@/ui-modules/core/form/layout/FormLabel.js";
import { FormNote } from "@/ui-modules/core/form/layout/FormNote.js";

// TODO should extend also from ICheckboxProps
export interface ICheckboxFieldProps extends Partial<WrappedFieldProps> {
  //input?: any; // injected as WrappedFieldProps
  //meta?: any; // injected as WrappedFieldProps

  className?: string;
  formGroupClassName?: string;
  label?: string | JSX.Element;
  tooltipText?: string;
  disabled?: boolean;
  onChange?: () => void;
  style?: any;
  horizontalLayout?: boolean;
  leftLabel?: string | ReactElement;
  info?: string | ReactElement;
}

/**
 * Checkbox field to be used in context of redux-form
 *
 * created on 1/24/2017
 */
const CheckboxField: FC<ICheckboxFieldProps> = (props) => {
  return (
    <FormInputGroup horizontalLayout={props.horizontalLayout} style={props.style}>
      {props.horizontalLayout && props.leftLabel && <FormLabel>{props.leftLabel}</FormLabel>}
      <FormInputWidget tooltip={props.tooltipText} style={props.style}>
        <div className={`checkbox check-default ${style.checkbox_radio}`}>
          <Checkbox
            id={props.input.name}
            {...props.input}
            checked={props.input.value}
            label={props.horizontalLayout ? "" : props.label}
            disabled={props.disabled}
            //tooltipText={props.tooltipText}
          />
        </div>
        {props.info && <FormNote>{props.info}</FormNote>}
      </FormInputWidget>
    </FormInputGroup>
  );
};

export default CheckboxField;

export function CheckboxReduxFormField(props: ICheckboxFieldProps & BaseFieldProps) {
  return <Field {...props} />;
}
